export default {"src":"/_next/static/media/NOV.1711f80f.svg","height":18,"width":18};